// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\TransactionResponse

import { TransactionOperation, PaymentStatus, PaymentMethod, PaymentPosMethod } from './enums.gen';
import { DateTimefromYmd, DateTimefromISO } from '#lib/helper/date.js';
import type { DateTime } from 'luxon';

export type TransactionApiResponse = {
	id: string;
	createdAt: string;
	effectiveDate: string;
	operation: TransactionOperation;
	status: PaymentStatus;
	method: PaymentMethod;
	amount: number;
	amountRefunded: number;
	fee: number;
	net: number;
	value: number;
	isSplitPayment: boolean;
	splitFee: number;
	ownerSplitFee: number;
	posMethod: PaymentPosMethod | null;
	parentPaymentId: string | null;
	giftcardCode: string | null;
	customerPackageId: string | null;
	customerPackageName: string | null;
	bookingId: string | null;
	bookingDate: string | null;
	bookingStartTime: string | null;
	bookingStatus: string | null;
	bookingPax: number | null;
	bookingPrice: number | null;
	bookingOffers: string | null;
	customerId: string | null;
	customerName: string | null;
	customerFirstname: string | null;
	customerLastname: string | null;
	customerEmail: string | null;
	customerPhone: string | null;
	giftcardOrderId: string | null;
	giftcardQuantity: number | null;
	giftcardName: string | null;
	customerPackageOrderId: string | null;
	billingInvoiceId: string | null;
};

export type Transaction = {
	id: string;
	createdAt: DateTime;
	effectiveDate: DateTime;
	operation: TransactionOperation;
	status: PaymentStatus;
	method: PaymentMethod;
	amount: number;
	amountRefunded: number;
	fee: number;
	net: number;
	value: number;
	isSplitPayment: boolean;
	splitFee: number;
	ownerSplitFee: number;
	posMethod: PaymentPosMethod | null;
	parentPaymentId: string | null;
	giftcardCode: string | null;
	customerPackageId: string | null;
	customerPackageName: string | null;
	bookingId: string | null;
	bookingDate: DateTime | null;
	bookingStartTime: string | null;
	bookingStatus: string | null;
	bookingPax: number | null;
	bookingPrice: number | null;
	bookingOffers: string | null;
	customerId: string | null;
	customerName: string | null;
	customerFirstname: string | null;
	customerLastname: string | null;
	customerEmail: string | null;
	customerPhone: string | null;
	giftcardOrderId: string | null;
	giftcardQuantity: number | null;
	giftcardName: string | null;
	customerPackageOrderId: string | null;
	billingInvoiceId: string | null;
};

export function hydrateTransaction(data: TransactionApiResponse): Transaction {
	return {
		...data,
		createdAt: DateTimefromISO(data.createdAt)!,
		effectiveDate: DateTimefromISO(data.effectiveDate)!,
		bookingDate: DateTimefromYmd(data.bookingDate),
	};
}